export default [{
  name: 'oilrecord',
  path: 'oilrecord',
  component: () => import('./Index.vue'),
  meta: {
    title: '油量统计'
  }
}]



// WEBPACK FOOTER //
// ./src/router/oil_record/index.js